/**
 * Created by h3 on 2018-09-10.
 */

export class FruitsStrings {
    public static COLLECT_SCATTERS:string = "Collect \n Scatter symbols";
    public static EXTRA_SPIN:string = "Extra spin";
    public static UPGRADE:string = "Upgrade";
    public static GET_LEVEL_UP:string = "Level up!";
    public static BONUS_WIN:string = "WIN";
}
